module.exports = __webpack_public_path__ + "img/title6_0.397d59d2.png";